import React from "react";
import SliderComponent from "./SliderComponent";
import { Button, Row, Col } from "antd";
import { useNavigate } from "react-router-dom";
import jeevamruthaPic from "./Images/jeevamrutha.jpg";
import WermiCompostPic from "./Images/WermiCompost.jpg";
import planting from "./Images/Planting.jpg";
import PaddyPlanting from "./Images/PaddingPlanting.jpg";
import Father from "./Images/Father.jpg";
import Mother from "./Images/Mother.jpg";
import RiceBag from "../src/Images/RiceBag.jpeg";
import About from "../src/Images/Father.jpeg";
import crop from "./Images/Crop.jpeg";
import "./global.css";

import Jeevamruthaprepration from "./Images/Jeevamruthaprepration.jpg";
import brand from "../src/Images/brand.jpg";

const Home = () => {
  const navigate = useNavigate();
  return (
    <div className="app" style={{ backgroundColor: "white" }}>
      <div
        className="logoMain"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <img
          className="brand"
          src={brand}
          width={"500px"}
          height={"500px"}
        ></img>
      </div>
      <SliderComponent />
      <h1 style={{ marginLeft: "50px", color: "#c9b377" }}>About</h1>
      <Row justify="space-around" style={{ border: "1px solid white" }}>
        <Col lg={12} xs={24} sm={24} md={12} className="about">
          <section
            className="AboutSection"
            style={{
              boxShadow: "0 0 1px grey",

              borderRadius: "10px",
              padding: "20px",
              fontSize: "16px",

              margin: "20px",
            }}
          >
            <h1 style={{ color: "#c9b377" }}>Pujari & Family</h1>
            <ul className="para1">
              <li>
                Welcome to Pujari & Family Farm Rice, a family-run venture
                rooted in generations of farming expertise. Our passion for
                sustainable agriculture and commitment to providing customers
                with the finest quality organically grown rice sets us apart.
              </li>
              <li>
                At Pujari & Family Farm Rice, we are dedicated to cultivating
                rice using organically grown methods. We firmly believe that by
                working in harmony with nature, we can produce food that is not
                only delicious but also healthier for our bodies and the
                environment.
              </li>
              <li>
                Our rice is grown without the use of synthetic fertilizers or
                harmful pesticides, ensuring that every grain carries the
                natural goodness that nature intended.
              </li>
              <li>
                We take pride in personally overseeing every step of the rice
                cultivation process, from planting the seeds to harvesting and
                processing. By eliminating intermediaries, we can directly
                deliver our premium rice to your doorstep, ensuring maximum
                freshness and traceability.
              </li>
              <li>
                With Pujari & Family Farm Rice, you can savor the authentic
                flavors of our carefully nurtured grains while supporting local
                farmers. By choosing Pujari & Family Farm Rice, you are not just
                purchasing rice; you are joining us on a sustainable journey.
              </li>
              <li>
                Together, we can make a positive impact on the environment,
                support ethical farming practices, and nourish our bodies with
                wholesome, organically grown food.
              </li>
            </ul>
            <Button
              style={{ marginTop: "10px", backgroundColor: "sandybrown" }}
              onClick={() => {
                navigate("/about"); // Use the navigate function to navigate to "/about"
              }}
            >
              Know More
            </Button>
          </section>
        </Col>
        <Col xs={24} md={12} xl={12} sm={24}>
          <section
            className="PlantingImage"
            style={{
              borderRadius: "10px",
              padding: "20px",

              alignItems: "center",
              textAlign: "center",
              margin: "20px",
            }}
          >
            <div className="mobilePic">
              <img
                src={crop}
                alt=""
                className="PlantingPic"
                style={{ width: "600px", height: "500px", margin: "10px" }}
              />
            </div>
          </section>
        </Col>
      </Row>

      <Row>
        <Col xs={24} md={12} xl={12} sm={24}>
          <section
            className="LowGiSection"
            style={{
              height: "450px",
              boxShadow: "0 0 1px grey",
              borderRadius: "10px",
              padding: "20px",
              margin: "20px",
            }}
          >
            <h1 style={{ fontSize: "40px", color: "brown", color: "#c9b377" }}>
              What is Low GI? And how is Low GI diet helpful?
            </h1>
            <p className="para" style={{ fontSize: "16px" }}>
              Low GI stands for "Low Glycemic Index." The glycemic index (GI) is
              a scale that ranks carbohydrates in foods based on how quickly
              they raise blood glucose (blood sugar) levels after consumption.
              Foods with a high GI are rapidly digested and absorbed, causing a
              rapid spike in blood sugar levels, while foods with a low GI are
              digested and absorbed more slowly, leading to a slower, more
              gradual increase in blood sugar levels.
            </p>

            <h3 style={{ color: "#c9b377" }}>The three GI ratings:</h3>
            <table className="table" border={"2px"} width={400}>
              <tr>
                <th>High</th>
                <th>Medium</th>
                <th>Low</th>
              </tr>
              <tr>
                <td>70 and above</td>
                <td>Between 56 and 69</td>
                <td>55 and lower</td>
              </tr>
            </table>
          </section>
        </Col>
        <Col xs={24} md={12} xl={12} sm={12} className="pic">
          <section
            className="containerpic"
            style={{
              height: "450px",
              borderRadius: "10px",
              padding: "20px",
              boxShadow: "0 0 1px grey",

              alignItems: "center",
              textAlign: "center",
              margin: "20px",
            }}
          >
            <img
              src="https://cdn-iepli.nitrocdn.com/mFySRqrKgUJpZqdwGcjAJKBjXdNbYFej/assets/images/optimized/rev-4e9e284/amuseeats.com/wp-content/uploads/2022/07/low-gi-rice.jpeg"
              alt=""
              className="img"
              style={{ width: "550px", height: "450px", margin: "0px" }}
            />
          </section>
        </Col>
      </Row>

      <Row>
        <Col lg={12} xs={24} sm={12} md={12}>
          <section
            className="CTRLGSection"
            style={{
              height: "1050px",
              boxShadow: "0 0 1px grey",
              borderRadius: "10px",
              padding: "20px",

              margin: "20px",
            }}
          >
            <h1 style={{ fontSize: "50px", color: "brown", color: "#c9b377" }}>
              A low GI diet is helpful for several reasons:
            </h1>

            <p className="para" style={{ fontSize: "16px" }}>
              <pre className="CTRLGSectionHeading">
                {" "}
                1. Blood Sugar Control:
              </pre>{" "}
              Low GI foods can help stabilize blood sugar levels, which is
              especially important for people with diabetes. By avoiding rapid
              spikes and crashes in blood sugar, individuals can better manage
              their condition and reduce the risk of complications.
              <pre className="CTRLGSectionHeading">
                {" "}
                2. Satiety and Weight Management:{" "}
              </pre>
              Low GI foods tend to provide longer-lasting feelings of fullness
              and satisfaction, which can help with appetite control and weight
              management. People are less likely to experience intense hunger
              shortly after eating low GI foods.
              <pre className="CTRLGSectionHeading">
                {" "}
                3. Improved Energy Levels:
              </pre>
              Foods with a low GI can provide a steady source of energy
              throughout the day, as they release glucose into the bloodstream
              gradually. This can help maintain energy levels and reduce
              fatigue.
              <pre className="CTRLGSectionHeading"> 4. Heart Health: </pre> A
              low GI diet may contribute to heart health by reducing the risk of
              insulin resistance, which is associated with cardiovascular
              disease. Additionally, low GI foods often include whole grains and
              fiber, which can help lower cholesterol levels. .
              <pre className="CTRLGSectionHeading">
                {" "}
                5. Better Overall Nutrition:{" "}
              </pre>{" "}
              Many low GI foods are nutrient-dense and rich in fiber, vitamins,
              and minerals. By choosing these foods, individuals can improve
              their overall nutrition and promote better health.
              <pre className="CTRLGSectionHeading">
                {" "}
                6.Reduces the Cancer Risk :
              </pre>
              It's essential to remember that cancer risk is influenced by a
              combination of factors, including genetics, lifestyle choices,
              environmental exposures, and overall dietary patterns. While a low
              GI diet can be part of a healthy lifestyle that may reduce certain
              risk factors for cancer, it should not be relied upon as the sole
              preventive measure. A well-rounded and balanced diet, regular
              physical activity, and other healthy lifestyle choices are crucial
              for reducing the overall risk of cancer and promoting overall
              well-being.
            </p>
          </section>
        </Col>
        <Col xs={24} md={12} xl={12} sm={12}>
          <section
            className="riceImage"
            style={{
              height: "1050px",

              borderRadius: "10px",
              padding: "20px",
              boxShadow: "0 0 1px grey",

              alignItems: "center",
              textAlign: "center",
              margin: "20px",
            }}
          >
            <img
              className="RiceBagImage"
              alt=""
              style={{ width: "500px", height: "750px", marginTop: "150px" }}
              src={RiceBag}
            />
          </section>
        </Col>
      </Row>
      <div style={{ width: "100%" }}>
        <h1
          style={{
            justifyContent: "center",
            display: "flex",
            color: "#c9b377",
          }}
        >
          Additional Advantages
        </h1>
        <div className="advantagesDiv ">
          <section style={{ margin: "20px" }}>
            <img
              src="data:image/jpeg;base64,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"
              alt=""
              width={300}
              height={400}
            />

            <h3
              style={{
                color: "#c9b377",
                justifyContent: "center",
                display: "flex",
              }}
            >
              Increases energy & endurance
            </h3>
          </section>
          <section style={{ margin: "20px" }}>
            <img
              src="https://thestorymug.com/wp-content/uploads/2020/07/Heart-Health.jpg"
              alt=""
              width={300}
              height={400}
            />
            <h3
              style={{
                color: "#c9b377",
                justifyContent: "center",
                display: "flex",
              }}
            >
              {" "}
              Promotes healthy heart
            </h3>
          </section>
          <section style={{ margin: "20px" }}>
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSu1-qrogskHeoLf8i6vU41eG18uuynUd7nQw&usqp=CAU"
              alt=""
              width={300}
              height={400}
            />
            <h3
              style={{
                color: "#c9b377",
                justifyContent: "center",
                display: "flex",
              }}
            >
              {" "}
              Boosts immune system
            </h3>
          </section>
          <section style={{ margin: "20px" }}>
            <img
              src="https://c.ndtvimg.com/pa3tlha_weight-loss_625x300_01_August_18.jpg"
              alt=""
              width={300}
              height={400}
            />
            <h3
              style={{
                color: "#c9b377",
                justifyContent: "center",
                display: "flex",
              }}
            >
              {" "}
              Aids in weight management
            </h3>
          </section>
          <section style={{ margin: "20px" }}>
            <img
              src="https://breakthroughcancerresearch.ie/wp-content/uploads/2022/02/Reduce-your-cancer-risk.png"
              alt=""
              width={300}
              height={400}
            />
            <h3
              style={{
                color: "#c9b377",
                justifyContent: "center",
                display: "flex",
              }}
            >
              Reduces risk of cancer
            </h3>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Home;
